import React, { useMemo } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { buildWhatsAppUrl } from "@/mock";

export default function WhatsAppFab({ phoneDigits, message }) {
  const url = useMemo(
    () => buildWhatsAppUrl({ phoneDigits, message }),
    [phoneDigits, message],
  );

  return (
    <div className="fixed bottom-5 left-5 z-50">
      <Button
        asChild
        size="lg"
        variant="cta"
        className="rounded-full px-5 shadow-lg transition-transform hover:scale-[1.02] active:scale-[0.98]"
      >
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          aria-label="Abrir WhatsApp"
        >
          <MessageCircle className="mr-2" />
          WhatsApp
        </a>
      </Button>
    </div>
  );
}
